import { render, staticRenderFns } from "./UpdateTaskParams.vue?vue&type=template&id=510d2429&"
import script from "./UpdateTaskParams.vue?vue&type=script&lang=js&"
export * from "./UpdateTaskParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports